import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTextGuide } from "../api/textGuide";

export function FullGuideLink({ testId }: { testId: string }) {
  return (
    <Link to="/text" data-testid={testId}
      className="inline-flex items-center gap-2 rounded-full border border-signal/60 bg-signal/10 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-signal/25">
      Full Text Guide <ArrowRight className="h-4 w-4" aria-hidden />
    </Link>
  );
}

export function CodesTable({ testId }: { testId: string }) {
  const { guide, failed } = useTextGuide();
  if (failed) return <p className="text-sm text-zinc-400" data-testid={`${testId}-error`}>Couldn't load the codes. See the <Link to="/text" className="text-signal">Text Guide</Link>.</p>;
  if (!guide) return <div className="h-40 animate-pulse rounded-[14px] bg-white/[0.04]" aria-hidden />;
  return (
    <div className="space-y-4">
      <div className="overflow-hidden rounded-[14px] border border-white/10">
        <table className="w-full text-left text-sm" data-testid={testId}>
          <thead className="bg-white/[0.04] text-[11px] uppercase tracking-wider text-zinc-400">
            <tr><th className="px-3 py-2 font-medium">Text</th><th className="px-3 py-2 font-medium">What it does</th></tr>
          </thead>
          <tbody>
            {guide.commands.map((c) => (
              <tr key={c.code} className="border-t border-white/5 align-top" data-testid={`${testId}-row-${c.code.toLowerCase()}`}>
                <td className="whitespace-nowrap px-3 py-2"><span className="font-mono font-semibold text-white">{c.forms.join(" / ")}</span>
                  {c.synonyms.length > 0 && <span className="block max-w-[12rem] whitespace-normal text-[11px] text-zinc-500">also {c.synonyms.join(", ")}</span>}</td>
                <td className="px-3 py-2 text-zinc-300">{c.does}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <FullGuideLink testId={`${testId}-full-guide-link`} />
    </div>
  );
}
